import {
    UPDATE_BREAKDOWN_SELECTED,
    UPDATE_FILTER_SELECTED,
    UPDATE_HELPFUL_COUNT,
    UPDATE_INDUSTRY_DROPDOWN_SELECTION,
    UPDATE_REVIEWS,
    UPDATE_THUMBS_SELECTED,
    UPDATE_WORK_SAMPLE_SELECTED,
    UPDATE_BUSINESS_SELECTED,
    CLEAR_ALL_FILTERS,
} from '../actions/types';
import { updateReviewsHelpful } from '../../utils/helpful';
import { removeEmptyEntries } from '../../utils';

export default (state = {}, action = {}) => {
    switch (action.type) {
        case UPDATE_REVIEWS:
            const updatedReviews = action.list.reviews;
            updateReviewsHelpful({ reviews: updatedReviews, helpfulMap: state.helpful });

            const shouldReset = action.isFilter;
            const updatedFilterCounters = action.list.filters_counters || state.filters_counters;
            const newReviewsList = shouldReset ? updatedReviews : state.reviews.concat(...updatedReviews);
            const filterCounters = shouldReset ? updatedFilterCounters : state.filters_counters;

            return {
                ...state,
                reviews: newReviewsList,
                has_next: action.list.has_next,
                filteredTotalCount: action.list.total_count,
                type: action.filterType,
                filters_counters: filterCounters,
                ignored_review_ids: action.list.ignored_review_ids,
            };
        case UPDATE_BREAKDOWN_SELECTED:
            return {
                ...state,
                selectedStars: action.value,
            };
        case UPDATE_THUMBS_SELECTED:
            return {
                ...state,
                helpful: {
                    ...state.helpful,
                    [action.id]: action.value,
                },
            };
        case UPDATE_HELPFUL_COUNT:
            return {
                ...state,
                reviews: state.reviews.map((review) => {
                    if (review.id === action.id) {
                        return {
                            ...review,
                            helpful_count: action.value,
                        };
                    }
                    return review;
                }),
            };
        case UPDATE_FILTER_SELECTED:
            return {
                ...state,
                filters: removeEmptyEntries({
                    ...state.filters,
                    ...action.value,
                }),
            };
        case CLEAR_ALL_FILTERS:
            return {
                ...state,
                filters: {},
            };
        case UPDATE_WORK_SAMPLE_SELECTED:
            return {
                ...state,
                workSampleChecked: action.value,
            };
        case UPDATE_BUSINESS_SELECTED:
            return {
                ...state,
                businessChecked: action.value,
            };
        case UPDATE_INDUSTRY_DROPDOWN_SELECTION:
            return {
                ...state,
                industryDropdownSelected: action.value,
            };
        default:
            return state;
    }
};
